import type { PublicDocument } from "@shared/public-document";

function setMeta(selector: string, content: string) {
  const node = document.querySelector(selector);
  if (node) node.setAttribute("content", content);
}

/** Browser adapter: keep the visible document in step after a client navigation. */
export function applyPublicDocument(doc: PublicDocument) {
  document.title = doc.title;
  setMeta('meta[name="description"]', doc.description);
  setMeta('meta[property="og:title"]', doc.title);
  setMeta('meta[property="og:description"]', doc.description);
  setMeta('meta[property="og:url"]', doc.canonical);
  setMeta('meta[name="twitter:title"]', doc.title);
  setMeta('meta[name="twitter:description"]', doc.description);
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute("href", doc.canonical);
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    document.head.appendChild(robots);
  }
  robots.setAttribute("content", doc.robots);
}
